module.exports = __webpack_public_path__ + "img/honour.3543e894.png";